import { useSelector } from 'react-redux';

export default function useSinks() {
  const sinks = useSelector((state: any) => state.entities.sinks);

  function getSinkById(id: number) {
    return sinks[id];
  }

  return {
    getSinkById,
    sinks,
  };
}
